import React, { useEffect, useState } from 'react'
import Container from '../../components/Container';
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import DataFetching from "../../utils/DataFetching";
import renderDataTable from "../../utils/renderDataTable";
import { ApiHandler } from "../../helper/ApiHandler";
import { ButtonDelete, ButtonEdit, formatMoment } from '../../helper/CommonFunction';
import Breadcrumb from '../../components/Breadcrumb';
import { BiSolidEdit } from 'react-icons/bi';
import { ModalSmall } from '../../components/ModalComponets';


const Bikes = () => {
    const location = useLocation();
    const token = useSelector((state) => state.user.userToken)

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [filteredData, setFilteredData] = useState([]);
    const [pending, setPending] = useState(true);
    const [resetSearch, setResetSearch] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageLimit, setPageLimit] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [deleteId, setdeleteId] = useState(null);
    const [deleteModal, setDeleteModal] = useState(false);

    const fetchData = async () => {
        setPending(true)

        const body = {
            page: currentPage - 1,
            perpage: pageLimit,
        }

        DataFetching(setPending, '/get_bikes_details.php', 'POST', token, dispatch, navigate, setFilteredData, setTotalPages, body, setResetSearch, resetSearch);
    };

    // Render the DataTable component
    useEffect(() => {
        if (!resetSearch) {
            return;
        }
        fetchData();
    }, [currentPage, pageLimit, location, resetSearch]);


    const DeleteUserModal = (row) => {
        setdeleteId(row);
        setDeleteModal(true);
    };

    const UserModal = (row) => {
        navigate(`/admin/bikes/edit/${row.id}`, { state: row });
    };

    const column = [
        {
            name: "Id",
            selector: (row) => row.id,
        },
        {
            name: "Title",
            selector: (row) => row.title,
        },
        {
            name: "Current Price",
            selector: (row) => row.current_price,
        },
        {
            name: "Category Name",
            selector: (row) => row.category_name,
        },
        {
            name: "Bike Image",
            selector: (row) => <Link to={row.image} target='_blank'><img height={50} src={row.image} alt="image_tag" style={{ width: "100%", objectFit: 'cover' }} /></Link>,
            sortable: true,
        },
        {
            name: "Transaction Date",
            selector: (row) => <span>{formatMoment(row.created_date)}</span>,
        },
        {
            name: "Actions",
            cell: (row) => (
                <div>
                    <ButtonEdit onclick={() => UserModal(row)} />
                    <ButtonDelete onclick={() => DeleteUserModal(row)} />
                </div>
            ),
        },
    ]

    const DeleteUser = async () => {
        const body = {
            bike_id: deleteId.id,
        }

        try {
            const result = await ApiHandler('/delete_bikes.php', 'POST', body, token, dispatch, navigate)
            if (result?.data.status === "1") {
                toast.success(result?.data.msg)
                setDeleteModal(false)
                setdeleteId(null);
                setResetSearch((prevReset) => !prevReset);
            } else {
                toast.error(result?.data.msg)
            }
        } catch (error) {
            setDeleteModal(false)
        }
    };
    return (
        <>
            <Breadcrumb pageName="Bikes" />
            <Container>
                <div className="border-2 border-solid border-[#ddddddbe] w-full">
                    <div className='p-3 w-full'>
                        <div className='py-3'>
                            {renderDataTable(
                                filteredData,
                                column,
                                pending,
                                currentPage,
                                setPageLimit,
                                setCurrentPage,
                                totalPages,
                                pageLimit,
                                setResetSearch,
                                dispatch,
                                navigate,
                            )}
                        </div>
                    </div>
                </div>
            </Container>
            {
                deleteId && deleteModal && (
                    <ModalSmall
                        isOpen={deleteModal}
                        onClose={() => setDeleteModal(false)}
                        onConfirm={DeleteUser}
                    >
                        <div>
                            <h2 className="text-xl font-bold text-gray-800 mb-1">Confirm!</h2>
                            <p className="text-sm text-gray-600 mb-4">
                                Are you sure you want to Delete this Bike?
                            </p>
                        </div>
                    </ModalSmall>
                )
            }
        </>
    )
}

export default Bikes;
